import { createSelector } from 'reselect'
import { getPageParams } from 'selectors/page'
export const getTrade = (state: Record<string, any>): Trade => state.trade || {}
export const getNewsletterEmail = createSelector([getTrade], (trade): string => trade.email || '')
export const getContact = createSelector([getTrade], (trade): string => trade.contact || '')
export const getContactLocal = createSelector(
  [getContact],
  (contact): string => contact.local || ''
)
export const getContactServer = createSelector(
  [getContact],
  (contact): string => contact.server || ''
)
export const getContactServerLoaded = createSelector(
  [getContactServer],
  (contactString): boolean => !!contactString.length || false
)
export const getContactLocalJSON = createSelector(
  [getContactLocal],
  (contactString): Record<string, any> => (contactString.length ? JSON.parse(contactString) : {})
)
export const getConfirmedContact = createSelector(
  [getContact],
  (contact): string => contact.confirmedContact || ''
)
export const getConfirmedContactLoaded = createSelector(
  [getConfirmedContact],
  (contactString): boolean => !!contactString.length || false
)
export const getConfirmedContactJSON = createSelector(
  [getConfirmedContact],
  (contactString): Record<string, any> => (contactString.length ? JSON.parse(contactString) : {})
)
export const getMyEmailContact = createSelector(
  [getTrade],
  (trade): string => trade.emailContact || ''
)
export const getContactConfirm = createSelector(
  [getContactServer],
  (server): string => server.contactConfirm || false
)
export const getSection = createSelector(
  [getPageParams],
  (params): string => params.section || 'landing'
)
export const getLayout = createSelector([getSection], (section): string =>
  section === 'landing' ? 'Landing' : 'Specialty'
)
const SEO = {
  hospitality: {
    title: 'Hospitality Art Advisory | Saatchi Art',
    description:
      'With a focus on Hospitality industries, Saatchi Art provides complimentary and comprehensive art advisory services for designers, trade associates, corporations, and institutions.',
  },
  commercial: {
    title: 'Commercial Art Advisory | Saatchi Art',
    description:
      'With a focus on Commercial industries, Saatchi Art provides complimentary and comprehensive art advisory services for designers, trade associates, corporations, and institutions.',
  },
  healthcare: {
    title: 'Healthcare Art Advisory | Saatchi Art',
    description:
      'With a focus on Healthcare industries, Saatchi Art provides complimentary and comprehensive art advisory services for designers, trade associates, corporations, and institutions.',
  },
  residential: {
    title: 'Residential Art Advisory | Saatchi Art',
    description:
      'With a focus on Residential industries, Saatchi Art provides complimentary and comprehensive art advisory services for designers, trade associates, corporations, and institutions.',
  },
  capabilities: {
    title: 'Art Advisory for Trade Services | Saatchi Art',
    description:
      'Saatchi Art provides complimentary and comprehensive art advisory services for designers, trade associates, corporations, and institutions. Our comprehensive process puts the client and their story front-and-center to deliver art programming that will enhance their space and showcase their creative vision effectively and efficiently.',
  },
  default: {
    title: 'Art Advisory for Trade Hospitality | Saatchi Art',
    description:
      'Saatchi Art provides complimentary and comprehensive art advisory services for members of national design firms as well as property owners and developers that specialize in hospitality, commercial and multi-family residential projects. Our commitment is to partner with you to find outstanding artworks for your client and projects, while also helping you meet budget and overall design concept goals.',
  },
}
export const getMetaData = createSelector(
  [getSection],
  (section): Record<string, any> => {
    const { title, description } = SEO[section] ?? SEO.default
    return {
      description,
      title,
      og: {
        description,
        image: 'https://d3t95n9c6zzriw.cloudfront.net/trade/hero/landing-hero-2023.jpg',
        title,
        ttl: '2419200',
        type: 'article',
      },
      preloadImages: [],
      robots: true,
      schema: {
        webpage: {
          description,
          headline: title,
        },
      },
    }
  }
)
